<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="hide"
    destroy-on-close
    append-to-body
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importFile"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button :disabled="confirmVisible" type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { settingApi, importApi, orderApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      exportData: [], // 存放上传的excel文件的数据
      confirmVisible: false,
      channelData: this.$store.getters.storePriceControl
    };
  },
  methods: {
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      importApi.getImportTemplateHeaders({
        templateCode: 'STHI.THIRD_ORDER_LOGISTICS_IMPORT',
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: res.content[0].templateUrl,
          })
          .then(resp => {
            downloadBlob(resp, res.content[0].templateFileName);
          });
      });
    },
    importFile(file) {
      this.confirmVisible = false;
      let errorMsg = '';
      const _this = this;
      _this.exportData = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function () {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
        });
        _this.exportData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        console.log(_this.exportData, '_this.exportData');
        // 数据的非空校验
        for (const item of Object.values(_this.exportData)) {
          if (!item.innerOrderNo) return _this.$message.error(_this.$t('ChannelManagement.Main.fileErrorMsg1'));
          if (!item.outerOrderNo) return _this.$message.error(_this.$t('ChannelManagement.Main.fileErrorMsg1'));
          if (!item.logisticsNo) return _this.$message.error(_this.$t('ChannelManagement.Main.fileErrorMsg1'));
          if (!item.logisticsBusinessName) return _this.$message.error(_this.$t('ChannelManagement.Main.fileErrorMsg1'));
        }
        //  innerOrderNo 去重
        const innerOrderNoArray = [...new Set(_this.exportData.map(item => item.innerOrderNo))].filter(item => _this.exportData.filter(obj => obj.innerOrderNo === item).length > 1);
        //  outerOrderNo 去重
        const outerOrderNoArray = [...new Set(_this.exportData.map(item => item.outerOrderNo))].filter(item => _this.exportData.filter(obj => obj.outerOrderNo === item).length > 1);
        //  logisticsNo 去重
        const logisticsNoArray = [...new Set(_this.exportData.map(item => item.logisticsNo))].filter(item => _this.exportData.filter(obj => obj.logisticsNo === item).length > 1);

        if (innerOrderNoArray.length) {
            _this.confirmVisible = true;
            innerOrderNoArray.forEach(item => (errorMsg += `${item}, `));
        }
        if (outerOrderNoArray.length) {
            _this.confirmVisible = true;
            outerOrderNoArray.forEach(item => (errorMsg += `${item}, `));
        }
        if (logisticsNoArray.length) {
            _this.confirmVisible = true;
            logisticsNoArray.forEach(item => (errorMsg += `${item}, `));
        }
        if (_this.confirmVisible) {
           errorMsg += _this.$t('ChannelManagement.Main.fileErrorMsg2');
           return _this.$message({ message: errorMsg, type: 'error', duration: 10000, showClose: true });
        }
      };
    },
    confirm() {
      console.log(this.exportData, this.exportData.length, this.confirmVisible, 'this.exportData.length && !this.confirmVisible');
      if (this.exportData.length && !this.confirmVisible) {
        orderApi.getStatisticsLogisticsListImport(this.exportData).then(res => {
         if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
           setTimeout(() => {
               this.hide();
               this.$emit('reFresh');
             }, 500);
         }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
